import { adminActionTypes as types } from 'src/redux/actions/adminActions';
import { omit } from 'lodash';

const initialState = {
  loading: false,
  error: null,
  admin: null,
};

export default function adminReducer(state = initialState, { type, data, error }) {
  switch (type) {
    case types.LOGIN_REQUEST:
    case types.LOGOUT_REQUEST:
    case types.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case types.LOGIN_SUCCESS:
    case types.UPDATE_PROFILE_SUCCESS:
      const cleanData = omit(data, ['auth', 'proactiveRefresh']); // these properties is not plain objects and will cause error when put to reducer
      return {
        ...state,
        loading: false,
        error: null,
        admin: cleanData
      }
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        admin: null
      }
    case types.LOGIN_FAILURE:
    case types.LOGOUT_FAILURE:
    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error
      }
    default:
      return state;
  }
}
